// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Mj9r-EZzuo7jfp6qGnJtn"};